module.exports = __webpack_public_path__ + "static/promote-financial-education-mobile.20915a62.webp";